var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63638 15.4331L12.525 20.2939L15.32 17.0128L19.0872 21.9952H3.77556L8.63638 15.4331Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63638 15.4331L12.525 20.2939L15.32 17.0128L19.0872 21.9952H3.77556L8.63638 15.4331Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43881 4.01015H16.6567C16.5352 4.25319 16.4137 4.61776 16.4137 4.8608C16.4137 5.58992 16.7782 6.19752 17.3858 6.56208H2.43881V24.5471H20.4239V9.11402C20.5454 10.0862 21.396 10.8153 22.3682 10.8153C22.6112 10.8153 22.8543 10.8153 23.0973 10.6938V24.5471C23.0973 26.0054 21.8821 27.0991 20.5454 27.0991H2.56033C1.10208 27.0991 0.00839696 25.8839 0.00839696 24.5471V6.56208C-0.113124 5.22536 1.10208 4.01015 2.43881 4.01015Z",
    fill: "#5B5B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43881 4.01015H16.6567C16.5352 4.25319 16.4137 4.61776 16.4137 4.8608C16.4137 5.58992 16.7782 6.19752 17.3858 6.56208H2.43881V24.5471H20.4239V9.11402C20.5454 10.0862 21.396 10.8153 22.3682 10.8153C22.6112 10.8153 22.8543 10.8153 23.0973 10.6938V24.5471C23.0973 26.0054 21.8821 27.0991 20.5454 27.0991H2.56033C1.10208 27.0991 0.00839696 25.8839 0.00839696 24.5471V6.56208C-0.113124 5.22536 1.10208 4.01015 2.43881 4.01015Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.722 8.32222C23.722 8.94444 23.0998 9.48889 22.4776 9.48889C21.8553 9.48889 21.3109 8.94444 21.3109 8.32222V5.98889H18.9776C18.3553 5.98889 17.8109 5.44444 17.8109 4.82222C17.8109 4.2 18.3553 3.65556 18.9776 3.65556H21.3109V1.32222C21.3109 0.544444 21.8553 0 22.4776 0C23.0998 0 23.6442 0.544444 23.6442 1.16667V3.5H25.9776C26.6776 3.57778 27.222 4.04444 27.222 4.74444C27.222 5.44444 26.6776 5.91111 26.0553 5.91111H23.722V8.32222Z",
    fill: "#5B5B5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.722 8.32222C23.722 8.94444 23.0998 9.48889 22.4776 9.48889C21.8553 9.48889 21.3109 8.94444 21.3109 8.32222V5.98889H18.9776C18.3553 5.98889 17.8109 5.44444 17.8109 4.82222C17.8109 4.2 18.3553 3.65556 18.9776 3.65556H21.3109V1.32222C21.3109 0.544444 21.8553 0 22.4776 0C23.0998 0 23.6442 0.544444 23.6442 1.16667V3.5H25.9776C26.6776 3.57778 27.222 4.04444 27.222 4.74444C27.222 5.44444 26.6776 5.91111 26.0553 5.91111H23.722V8.32222Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.691c513b380197f985fe2c75f8f4ab06.svg";
export { ForwardRef as ReactComponent };